const DIRECTOR_ACTION_TYPE = {
  GET_DIRECTORS: 'GET_DIRECTORS',
  GET_DIRECTOR: 'GET_DIRECTOR',
  CREATE_DIRECTOR: 'CREATE_DIRECTOR',
  UPDATE_DIRECTOR: 'UPDATE_DIRECTOR',
  DELETE_DIRECTOR: 'DELETE_DIRECTOR',
  CREATE_DIRECTOR_NOTE: 'CREATE_DIRECTOR_NOTE',
  UPDATE_DIRECTOR_NOTE: 'UPDATE_DIRECTOR_NOTE',
  DELETE_DIRECTOR_NOTE: 'DELETE_DIRECTOR_NOTE'
}
export default DIRECTOR_ACTION_TYPE
